import { connect } from "react-redux";
import { requestWelcomeMessage } from "@template/state/modules/welcomeMessage/actions";
import { getPlatform } from "@template/state/modules/layout";
import { getFeaturesLoaded } from "@template/state/modules/features";
import WelcomeMessageContainer from "./WelcomeMessageContainer";

const mapStateToProps = state => ({
  isFeaturesLoaded: getFeaturesLoaded(state),
  platform: getPlatform(state),
  redirectUrl: state.welcomeMessage.redirectUrl,
  country: state.welcomeMessage.country,
  browsingLocalStore: state.welcomeMessage.browsingLocalStore
});

const mapDispatchToProps = {
  requestWelcomeMessage
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WelcomeMessageContainer);
